import { render, staticRenderFns } from "./ViewKnowledgeAdmin.vue?vue&type=template&id=463525fc&scoped=true"
import script from "./ViewKnowledgeAdmin.vue?vue&type=script&lang=js"
export * from "./ViewKnowledgeAdmin.vue?vue&type=script&lang=js"
import style0 from "./ViewKnowledgeAdmin.vue?vue&type=style&index=0&id=463525fc&prod&lang=css"
import style1 from "./ViewKnowledgeAdmin.vue?vue&type=style&index=1&id=463525fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463525fc",
  null
  
)

export default component.exports